import React from "react";
import './Empty.css';
import { SmileySad } from "phosphor-react";
const Empty = ({ icon, title, subtitle }) => {
    return (
        <div className="empty-component-container">
            <div>
                {icon === "SmileySad" ?
                    <SmileySad size={40} />
                    :
                    null
                }
            </div>
            <div className="empty-title t4 ">
                {title}
            </div>
            <div className="empty-subtitle t6">
                {subtitle}
            </div>
        </div>
    )
}

export default Empty;